/**
 * Accessibility Module
 *
 * Adds missing labels and ARIA attributes for third-party widgets.
 */

/**
 * @param {Element} facet
 * @param {'min' | 'max'} field
 * @returns {HTMLInputElement | null}
 */
function getFacetDateInput(facet, field) {
    const inputs = facet.querySelectorAll(`input.facetwp-date-${field}`);

    if (!inputs.length) {
        return null;
    }

    const visibleInput = Array.from(inputs).find((input) => {
        const style = window.getComputedStyle(input);

        return style.display !== 'none' && style.visibility !== 'hidden';
    });

    return visibleInput || inputs[0];
}

/**
 * @param {HTMLInputElement | null} input
 * @param {string} id
 * @param {string} labelText
 */
function ensureDateInputLabel(input, id, labelText) {
    if (!input) {
        return;
    }

    if (!input.id) {
        input.id = id;
    }

    if (document.querySelector(`label[for="${id}"]`)) {
        return;
    }

    const label = document.createElement('label');
    label.setAttribute('for', id);
    label.className = 'screen-reader-text';
    label.textContent = labelText;

    input.parentNode.insertBefore(label, input);
}

/**
 * Add screen-reader labels to FacetWP agenda date inputs.
 */
function initAgendaDateFacetLabels() {
    const dateFacet = document.querySelector('.facetwp-facet-agenda_dates');

    if (!dateFacet) {
        return;
    }

    ensureDateInputLabel(
        getFacetDateInput(dateFacet, 'min'),
        'agenda-date-start',
        'Date de début'
    );

    ensureDateInputLabel(
        getFacetDateInput(dateFacet, 'max'),
        'agenda-date-end',
        'Date de fin'
    );
}

/**
 * Initialize accessibility enhancements.
 */
export function initAccessibility() {
    document.addEventListener('facetwp-loaded', initAgendaDateFacetLabels);

    // FacetWP peut finir avant notre script defer : exécuter tout de suite aussi.
    initAgendaDateFacetLabels();
}
